import React from 'react';
import '../App.css';
import './blogpost.css';
import IntroVideo from '../images/purple_sparkles.mp4';
import VideoComponent from './VideoComponent.js';
import { useParams, useNavigate } from 'react-router-dom';
import { useScrollBehavior } from './useScrollBehavior.js';
import Footer from './footer.js';
import blogPosts from './blogData.js';

const BlogArticle = () => {
  useScrollBehavior();

  const { slug } = useParams();
  const navigate = useNavigate();

  const post = blogPosts.find((item) => item.slug === slug);

  if (!post) {
    return (
      <>
     
        <div id="blog_article_page">
          <div id="blog_article_not_found">
            <h1>Article Not Found</h1>
            <button
              type="button"
              onClick={() => {
                navigate('/blog');
                window.scrollTo(0, 0);
              }}
            >
              Back to Blog
            </button>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
     <VideoComponent  videoSrc={IntroVideo} />
      <div id="blog_article_page">
        <div id="blog_article_hero">
          <div id="blog_article_hero_inner">
            <div id="blog_article_category">{post.category}</div>
            <h1>{post.title}</h1>
            <p id="blog_article_date">{post.date}</p>
            <p id="blog_article_description">{post.description}</p>
          </div>
        </div>

        <div id="blog_article_body_wrap">
          <div id="blog_article_body">
            {post.content.map((block, index) => {
              if (block.type === 'heading') {
                return <h2 key={index}>{block.text}</h2>;
              }

              return <p key={index}>{block.text}</p>;
            })}
          </div>

          <div id="blog_article_button_row">
            <button
              type="button"
              onClick={() => {
                navigate('/blog');
                window.scrollTo(0, 0);
              }}
            >
              Back to Blog
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default BlogArticle;